import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Seo from '../components/Seo';
import { ChatWidget, BackToTop } from '../components/ChatAndUtils';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLegalDoc, LegalSections, TranslationNotice } from '../components/LegalTexts';

const Impressum = () => {
  const { t } = useTranslation();
  const [forceDe, setForceDe] = useState(false);
  const doc = useLegalDoc('impressum', forceDe ? 'de' : undefined);
  return (
    <div className="min-h-screen bg-white">
      <Seo
        title="Impressum – Kanzlei Nabhan Gäbler & Partner"
        description="Impressum und Anbieterkennzeichnung gemäß § 5 DDG der Kanzlei Nabhan Gäbler & Partner in Bonn."
        path="/impressum"
      />
      <Header />
      <main className="pt-[150px]">
        <section className="bg-[#1B3A5C] text-white py-14 relative overflow-hidden">
          <div className="absolute inset-0 opacity-10 pointer-events-none">
            <div className="absolute top-0 right-0 w-72 h-72 bg-[#b8893d] rounded-full blur-3xl"></div>
          </div>
          <div className="relative max-w-4xl mx-auto px-6 lg:px-10">
            <Link to="/" className="inline-flex items-center gap-1 text-white/70 text-sm hover:text-[#b8893d] mb-4">
              <ArrowLeft className="w-3.5 h-3.5" /> {t('common.back_home', 'Zurück zur Startseite')}
            </Link>
            <div className="inline-flex items-center gap-3 text-[#e0b56a] text-xs tracking-[0.3em] mb-3">
              <span className="w-12 h-px bg-[#b8893d]" />
              {t('legal_pages.impressum.kicker')}
            </div>
            <h1 className="font-serif font-light text-4xl md:text-5xl tracking-tight">{t('legal_pages.impressum.title')}</h1>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-6 lg:px-10" data-testid="impressum-content">
            <TranslationNotice doc={doc} forceDe={forceDe} setForceDe={setForceDe} testid="impressum" />
            {doc ? <LegalSections sections={doc.sections} /> : <p className="text-[#34536b] text-sm italic">Inhalte werden geladen …</p>}
            <p className="mt-12 pt-6 border-t border-gray-100 text-xs text-[#9aa5b1] text-center">
              © {new Date().getFullYear()} Kanzlei Nabhan Gäbler &amp; Partner
            </p>
          </div>
        </section>
      </main>
      <Footer />
      <ChatWidget />
      <BackToTop />
    </div>
  );
};

export default Impressum;
